import React, { useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./DashSidebar.css";
import { AuthContext } from "../../context/AuthContext";

const DashSidebar = () => {
  const { userName, userType } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("userType");
    navigate("/login");
  };

  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  if (userType === "admin") {
    return (
      <div className="DashSidebar light-border d-flex flex-column align-items-center align-items-sm-start min-vh-100">
        <div className="text-center w-100 user-detail-block pt-3">
          <img
            className="user-img"
            src={require("../../assets/user-img.png")}
            alt=""
          />
          <h5>Welcome {userName}</h5>
          <button onClick={handleLogout} className="btn btn__primary">
            Logout
          </button>
        </div>
        <ul className="nav w-100" id="menu">
          <li className={`nav-link ${getActiveClass("/dashboard")}`}>
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/users")}`}>
            <Link to="/users">Users</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/tax")}`}>
            <Link to="/tax">Taxation</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/media")}`}>
            <Link to="/media">Media</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/dashproduct")}`}>
            <Link to="/dashproduct">Diamonds</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/dashjewelry")}`}>
            <Link to="/dashjewelry">Jewellery</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/admin-order")}`}>
            <Link to="/admin-order">Order</Link>
          </li>
        </ul>
      </div>
    );
  }

  if (userType === "customer") {
    return (
      <div className="DashSidebar light-border d-flex flex-column align-items-center align-items-sm-start min-vh-100">
        <div className="text-center w-100 user-detail-block pt-3">
          <img
            className="user-img"
            src={require("../../assets/user-img.png")}
          />
          <h5>Welcome {userName}</h5>
          <button onClick={handleLogout} className="btn btn__primary">
            Logout
          </button>
        </div>
        <ul className="nav w-100" id="menu">
          <li className={`nav-link ${getActiveClass("/dashboard")}`}>
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/")}`}>
            <Link to="/">Recent Orders</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/")}`}>
            <Link to="/">Coupons</Link>
          </li>
          <li className={`nav-link ${getActiveClass("/")}`}>
            <Link to="/">Offers</Link>
          </li>
        </ul>
      </div>
    );
  }
};

export default DashSidebar;
